import swiperUtil from '../utils/swiper-util';

export default (node) => {
  const swiperNode = node.querySelector('[data-swiper]');
  const buttonNext = node.querySelector('[data-next]');
  const buttonPrev = node.querySelector('[data-prev]');

  const initSwiper = () => {
    swiperUtil(swiperNode, {
      spaceBetween: 0,
      slidesPerView: 1.5,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 3.2,
        },
      },
    });
  };

  if (swiperNode) initSwiper();
};
